import { actions } from './floor/actions'
import { getters } from './floor/getters'
import { state } from './floor/state'
import { mutations } from './floor/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
